// extracted by mini-css-extract-plugin
export default {"input_block":"styled_input_block__br1lh","input":"styled_input__wejxO"};